<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import IspDataRow from './IspDataRow.vue';
import { getCsatRatingInfo, renderStars } from './useIspStatusStyles'; // GK-HUB: Sidebar CSAT

const currentChat = useMapGetter('getSelectedChat');
const contactGetter = useMapGetter('contacts/getContact');

const contactId = computed(() => currentChat.value?.meta?.sender?.id);
const contact = computed(() => contactGetter.value(contactId.value) || {});
const attrs = computed(() => contact.value.custom_attributes || {});

const tempoCliente = computed(() => {
  const desde = attrs.value.cliente_desde;
  if (!desde) return '';
  const start = new Date(desde);
  const now = new Date();
  if (Number.isNaN(start.getTime())) return '';

  let years = now.getFullYear() - start.getFullYear();
  let months = now.getMonth() - start.getMonth();
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years > 0 && months > 0)
    return `${years} ano${years > 1 ? 's' : ''} e ${months} mes${months > 1 ? 'es' : ''}`;
  if (years > 0) return `${years} ano${years > 1 ? 's' : ''}`;
  if (months > 0) return `${months} mes${months > 1 ? 'es' : ''}`;
  return 'Menos de 1 mês';
});

// GK-HUB: Sidebar CSAT — contact average
const csatStats = computed(() => contact.value.csat_stats);
const csatAvgInfo = computed(() =>
  csatStats.value
    ? getCsatRatingInfo(Math.round(csatStats.value.average_rating))
    : null
);
// GK-HUB: end Sidebar CSAT
</script>

<template>
  <div class="flex flex-col px-4 py-1">
    <IspDataRow label="CPF" :value="attrs.cpf" />
    <IspDataRow
      label="Cod. Cliente"
      :value="attrs.cod_cliente ? `#${attrs.cod_cliente}` : ''"
      mono
    />
    <IspDataRow label="Endereço" :value="attrs.endereco" small />
    <IspDataRow label="Cliente há" :value="tempoCliente" />
    <IspDataRow
      label="Contratos"
      :value="attrs.qtd_contratos"
      :no-divider="!csatStats"
    />
    <!-- GK-HUB: Sidebar CSAT — contact average -->
    <IspDataRow
      v-if="csatStats"
      :label="$t('CONVERSATION_SIDEBAR.ACCORDION.ISP_SATISFACAO')"
      no-divider
    >
      <div class="flex items-center gap-1.5">
        <span class="text-xs tracking-wider" :class="csatAvgInfo.star">
          {{ renderStars(Math.round(csatStats.average_rating)) }}
        </span>
        <span class="text-[11px] font-medium text-n-slate-11">
          {{ csatStats.average_rating }}
        </span>
        <span class="text-[10px] text-n-slate-10">
          ({{ csatStats.total_responses }})
        </span>
      </div>
    </IspDataRow>
    <!-- GK-HUB: end Sidebar CSAT -->
  </div>
</template>
